var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99844 0.000610352C6.47366 0.000610352 4.45196 1.15051 2.98021 2.51914C1.51784 3.87527 0.539797 5.50013 0.077337 6.61566C-0.025779 6.86252 -0.025779 7.13749 0.077337 7.38435C0.539797 8.49987 1.51784 10.1247 2.98021 11.4809C4.45196 12.8495 6.47366 13.9994 8.99844 13.9994C11.5232 13.9994 13.5449 12.8495 15.0167 11.4809C16.479 10.1216 17.4571 8.49987 17.9227 7.38435C18.0258 7.13749 18.0258 6.86252 17.9227 6.61566C17.4571 5.50013 16.479 3.87527 15.0167 2.51914C13.5449 1.15051 11.5232 0.000610352 8.99844 0.000610352ZM13.498 7C13.498 9.48416 11.4826 11.4996 8.99844 11.4996C6.51428 11.4996 4.49883 9.48416 4.49883 7C4.49883 4.51584 6.51428 2.50039 8.99844 2.50039C11.4826 2.50039 13.498 4.51584 13.498 7ZM8.99844 5.00018C8.99844 6.10321 8.10164 7 6.99861 7C6.63927 7 6.3018 6.90626 6.0112 6.73753C6.00495 6.82502 5.9987 6.90939 5.9987 7C5.9987 8.65611 7.34233 9.99974 8.99844 9.99974C10.6545 9.99974 11.9982 8.65611 11.9982 7C11.9982 5.3439 10.6545 4.00026 8.99844 4.00026C8.91095 4.00026 8.82345 4.00339 8.73596 4.01276C8.90157 4.30336 8.99844 4.64083 8.99844 5.00018Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSolid);
export default __webpack_public_path__ + "static/media/eye-solid.453e03fc9bfda36f4c5932064b6f1c06.svg";
export { ForwardRef as ReactComponent };